import { clearSnapshotCache } from '@platform/accesszen-react'
import { clearAnalyticsCache } from '@/hooks/analytics/analytics-cache-persistence'
import { clearLastWorkspaces } from '@/lib/last-workspace-store'
import { clearReturnPath } from '@/lib/return-path-store'

/**
 * Everything the platform keeps in browser storage per signed-in identity (localStorage,
 * plus the permission snapshot in sessionStorage, which outlives logout/login within a
 * tab). Called from every session-end site (both layouts' `onLogout` and the /login mount)
 * so a new identity on the same browser starts clean. Ref: ASC-10715, ASC-10749, ASC-10848
 */
export function clearSessionLocalState(): void {
  clearLastWorkspaces()
  clearAnalyticsCache()
  clearSnapshotCache()
  clearReturnPath()
}
